export enum ImageType {
    BASE64= "BASE64",
    FONTAWESOME_ICON= "FONTAWESOME_ICON",
}


// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/models/image-type.ts